export const MINIMUM_APP_VERSION_FOR_ABLY = '2.1.6'

/**
 * Strips any pre-release or build-metadata suffix from a semver string.
 * Example: "2.2.0-animation.97" -> "2.2.0"
 */
function stripPreReleaseSuffix(version: string): string {
  return version.replace(/[-+].*$/, '')
}

/**
 * Converts a semantic version string to a comparable number.
 * Pre-release suffixes (e.g. "-animation.97") are stripped before parsing.
 * Example: "2.1.3" -> 2001003
 * Example: "2.2.0-animation.97" -> 2002000
 */
function versionToNumber(version: string): number {
  try {
    const parts = stripPreReleaseSuffix(version).split('.').map(Number)

    if (parts.length < 3 || parts.some(isNaN)) {
      return 0
    }

    const [major, minor, patch] = parts
    return major * 1000000 + minor * 1000 + patch
  } catch (error) {
    return 0
  }
}

const MINIMUM_VERSION_NUMBER = versionToNumber(MINIMUM_APP_VERSION_FOR_ABLY)

/**
 * Checks if terminal app version meets minimum requirement for Ably support.
 */
export function isAblyCommunicationSupported(appVersion: string): boolean {
  const trimmedVersion = appVersion.trim()

  if (trimmedVersion === '') {
    return false
  }

  return versionToNumber(trimmedVersion) >= MINIMUM_VERSION_NUMBER
}
